import domReady from '@wordpress/dom-ready';

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

domReady( () => {
	const mySwiper = new Swiper( '.swiper-container', {
		loop: true,
		autoplay: {
			delay: 4000,
		},
		speed: 2000,

		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	} );
} );
